import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1010%3A23781&mode=dev)
 * */

const RightIcon = (props: SvgProps) => (
  <Svg width={12} height={12} {...props}>
    <path
      className="stroke-current"
      strokeLinecap="round"
      d="M4 2l4 4.002L4 10"
    />
  </Svg>
);

export default RightIcon;
